window.LandscapeOverlay = PortraitOverlay.extend({

    initialize: function(properties) {
        this.isPortrait = null;
        this.isViewportSet = false;
        this.xmlPath = properties.xml;
        // render in English by default
        this.language = properties.language == -1 ? "en" : properties.language;

        this.loadXML();
    },

    loadXML: function() {
        var loader = new AssetLoader({
            name: "LaunchPage"
        });
        loader.addXML(this.xmlPath);
        this.listenToOnce(loader, "onAssetLoaded", this.handleXmlLoaded);

        loader.start();
    },

    handleXmlLoaded: function(e) {
        var $xml = $(e.resource.getXML());
        this.data = this.getData($xml);
        this.render();
    },

    // Update DOM after language select
    updateLanguage: function(language) {
        this.$overlayTitle.text(this.data[language].title);
        this.$overlayMessage.text(this.data[language].message);
    },

    render: function() {
        var $wrapper = $("#wrapper");

        $wrapper.append(this.getContent(this.data[this.language]));

        this.$overlay = $wrapper.children().last();
        this.$overlayTitle = $wrapper.find(".overlay-title");
        this.$overlayMessage = $wrapper.find(".overlay-message");

        if(!BrowserDetect.isMobileDevice) {
            this.$overlay.toggle(false);
            this.trigger("onViewportSet", {target: this, scale: 1});
            return;
        }

        $(window).resize(function() {
            // delay required for older versions of iOS where orientation is updated after resize
            _.delay(this.handleResize.bind(this), 50);
        }.bind(this));
        this.handleResize();
    },

    isOrientationPortrait: function() {
        // prefer new screen orientation API if available
        if(window.screen.orientation != null && window.screen.orientation.angle != null) {
            return window.screen.orientation.angle === 0 || window.screen.orientation.angle === 180;
        }

        // window.orientation is deprecated but currently seems to be the only method reliable on iOS
        if(window.orientation != null) {
            return window.orientation === 0 || window.orientation === 180;
        }

        // do not show popup if we can't detect orientation
        return true;
    },

    getContent: function(data) {
        return Handlebars.templates["components/portraitoverlay"](data);
    },

    getData: function($xml) {
        var data = [];
        _.each($xml.find("optionList").find("row > index"), function(item, i) {
            var $item = $(item);
            var language = $item.find("param1").find("en").find("text").text();
            data[language] = {
                title:$item.find("param2").find("en").find("text").text(),
                message:$item.find("param3").find("en").find("text").text(),
            };
        });
        return data;
    },

    handleResize: function() {
        var isPortraitCurrent = this.isOrientationPortrait();
        Logger.info("isPortrait", isPortraitCurrent);
        if(this.isPortrait !== isPortraitCurrent) {
            this.handleOrientationChange({isPortrait: isPortraitCurrent});
        }
    },

    handleOrientationChange: function(e) {
        this.isPortrait = e.isPortrait;
        this.$overlay.toggle(!this.isPortrait);

        if(this.isPortrait && !this.isViewportSet) {
            this.setViewport();
        }
    },

    setViewport: function() {
        var screenHeight = window.innerHeight;

        if (screenHeight < 720) {
            var scale = Math.round(screenHeight / 720 * 100) / 100;
            var mvp = document.getElementById('myViewport');
            mvp.setAttribute('content', 'width=device-width, initial-scale=' + scale);
        }

        Logger.info("Viewport scale:", scale);

        if(self != top) {
            var viewport = self.document.querySelector("meta[name=viewport]");
            var parentViewport = top.document.querySelector("meta[name=viewport]");

            if(parentViewport) {
                parentViewport.setAttribute("content", viewport.getAttribute("content"));
            } else {
				var meta = top.document.createElement('meta');
				meta.name = "viewport";
				meta.content = viewport.getAttribute("content");
				top.document.getElementsByTagName('head')[0].appendChild(meta);
			}
        }

        this.isViewportSet = true;
        this.trigger("onViewportSet", {target: this, scale: scale});
    }
});
